/*eslint-disable */
define(function (require) {
    'use strict';

    var Backbone = require('backbone'),
        xhrUris = require('common/xhr-uris');


    var AvailabilityPageModel = Backbone.Model.extend({
        url: xhrUris.checkoutAvailabilityServices,

        initialize: function () {}
    });

    return AvailabilityPageModel;
});
